import { useLocation, Link } from "react-router-dom";
import { useEffect, useState } from "react";
import logoImage from '@/assets/logo.png';

const NotFound = () => {
  const location = useLocation();
  const [count, setCount] = useState(5);

  useEffect(() => {
    console.error(
      "404 Error: User attempted to access non-existent route:",
      location.pathname
    );

    // Countdown timer untuk redirect otomatis
    const timer = count > 0 && setInterval(() => setCount(count - 1), 1000);
    if (count === 0) window.location.href = "/";
    return () => clearInterval(timer as NodeJS.Timeout);
  }, [location.pathname, count]);

  return (
    <div className="min-h-screen flex flex-col items-center justify-center bg-gradient-to-b from-primary/5 to-union-red/5 p-4">
      <div className="max-w-md w-full bg-white rounded-xl shadow-xl p-8 text-center relative overflow-hidden">
        {/* Efek dekoratif */}
        <div className="absolute -top-10 -left-10 w-40 h-40 bg-primary/10 rounded-full blur-xl"></div>
        <div className="absolute -bottom-10 -right-10 w-40 h-40 bg-union-red/10 rounded-full blur-xl"></div>
        
        {/* Logo */}
        <img src={logoImage} alt="Logo" className="h-16 w-16 mx-auto mb-4" />
        
        {/* Angka 404 dengan efek */}
        <h1 className="text-8xl font-bold mb-4 text-transparent bg-clip-text bg-gradient-to-r from-primary to-union-red animate-pulse">404</h1>
        
        {/* Pesan error */}
        <h2 className="text-2xl font-bold mb-2 text-gray-800">Halaman Tidak Ditemukan</h2>
        <p className="text-gray-600 mb-6">
          Maaf, halaman yang Anda cari <span className="font-semibold text-union-red">{location.pathname}</span> tidak tersedia.
        </p>
        
        {/* Tombol kembali dengan efek hover */}
        <Link to="/" className="inline-block px-6 py-3 bg-gradient-to-r from-primary to-union-red text-white font-medium rounded-lg shadow-md hover:shadow-lg transform hover:-translate-y-1 transition-all duration-300">
          Kembali ke Beranda
        </Link>
        
        {/* Countdown timer */}
        <p className="mt-4 text-sm text-gray-500">
          Anda akan dialihkan ke beranda dalam <span className="font-bold">{count}</span> detik
        </p>
      </div>
      
      {/* Informasi tambahan */}
      <div className="mt-6 text-sm text-gray-500 max-w-md text-center">
        Jika Anda yakin alamat ini seharusnya benar, silakan hubungi administrator sistem atau kembali ke halaman sebelumnya.
      </div>
    </div>
  );
};

export default NotFound;
